import { action, payload } from 'ts-action'
import { IError, IPayload } from '@network/models/global.model'
import { IUser } from '@network/models/user.model'

export const ManagersFetching = action('ManagersFetching', payload<boolean>())
export const GetManagers = action('GetManagers', payload<IPayload<IUser[]>>())
export const GetManagersError = action('GetManagersError', payload<IError>())
export const DeleteManager = action('DeleteManager', payload<number>())
